<template>
  <div id="punchClock">
    <div class="c-t"></div>
    <div class="c-m">
      <div class="c-m-l"></div>
      <div class="c-m-r">
        <div>{{ userInfo.staffName || staffNameInCookies }}</div>
        <div>{{ userInfo.postOffice || postOfficeInCookies }}</div>
      </div>
      <!-- <div class="c-m-remark" @click="isRemarks = true">
        <i></i>
        <span>备注</span>
      </div> -->
    </div>
    <div class="c-c">
      <div class="c-c-clock">
        <div class="entName">
          {{ userInfo.entName || entNameInCookies }}
        </div>
        <div class="date-time">
          {{ year + '年' + month + '月' + day + '日' }}
        </div>
        <van-loading
          color="#1989fa"
          size="36px"
          type="spinner"
          v-show="Object.keys(clockInInfo).length == 0"
        />
        <!-- 是否在考勤组内 -->
        <template v-if="clockInInfo.punchGroupStatus == 1">
          <!-- 是否在打卡日内 -->
          <template v-if="clockInInfo.punchDateStatus == 1">
            <div
              class="clock"
              :class="
                clockInInfo.punchOutStatus === 1 &&
                clockInInfo.punchGroupStatus == 1
                  ? 'une'
                  : 'e'
              "
              @click="clock"
            >
              <div class="clock-text" v-if="clockInInfo.extraWork === 0">
                {{
                  clockInInfo.punchOutStatus === 1
                    ? `异地办公${
                        this.clockInInfo.punchStatus === 1 ? '上班' : '下班'
                      }打卡`
                    : `正常${
                        this.clockInInfo.punchStatus === 1 ? '上班' : '下班'
                      }打卡`
                }}
              </div>
              <div v-else class="clock-text">
                {{
                  clockInInfo.punchOutStatus === 1
                    ? `异地办公加班${
                        this.clockInInfo.punchStatus === 1 ? '上班' : '下班'
                      }打卡`
                    : `加班${
                        this.clockInInfo.punchStatus === 1 ? '上班' : '下班'
                      }打卡`
                }}
              </div>
              <div class="clock-time">
                {{ hour + ':' + minute + ':' + second }}
              </div>
            </div>
            <div class="address">
              <van-icon name="location" />当前位置距离公司<span>{{
                nowDistance
              }}</span
              >米
              <div class="address-name">
                考勤地点：{{ clockInInfo.placeName }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="clock une">
              <div class="clock-text" style="font-size: 16px">
                当前不是打卡日
              </div>
              <div class="clock-time" style="font-size: 12px">
                非打卡日不允许打卡
              </div>
            </div>
          </template>
        </template>
        <template v-else-if="clockInInfo.punchGroupStatus == 2">
          <div class="clock une">
            <div class="clock-text">您未在考勤组里</div>
            <div class="clock-time" style="font-size: 12px; text-align: center">
              请联系企业管理员<br />添加到考勤组中
            </div>
          </div>
        </template>
      </div>
    </div>
    <van-popup v-model="isFieldClock" position="bottom">
      <div class="field-msg">您正在使用异地办公打卡</div>
      <div class="field-info">
        <van-form validate-first @failed="onFailed" @submit="clock('on')">
          <div class="field-detail">
            <van-field
              :rules="[{ required: true, message: '' }]"
              v-model="fieldClockParam.punchOutThs"
              rows="2"
              autosize
              required
              type="textarea"
              placeholder="请输入异地办公事由"
              show-word-limit
            />
            <van-uploader
              capture
              v-model="fileList"
              :max-count="1"
              :after-read="afterRead"
            />
          </div>
          <van-button
            type="info"
            size="normal"
            class="field-clock-btn"
            native-type="submit"
            >异地办公打卡</van-button
          >
        </van-form>
      </div>
    </van-popup>
    <div v-if="isRemarke" class="popup_remark" @click="record">
      <i></i>
      备注记录
    </div>
    <remarks
      v-if="isRemarks"
      class="remark"
      :addressList="addressList"
      @showRemark="showRemark"
    ></remarks>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import {
  clockInInfo,
  clockIn,
  uploadImg,
  saveRecord,
  saveUVRecord,
  getWeChatAddress
} from '@api/lishui'
import axios from 'axios'
import { getLocalStorage, setLocalStorage } from '@utils'
import remarks from './remarks'
import wx from 'weixin-js-sdk'
export default {
  name: 'PunchClock',
  props: {},
  components: {
    remarks
  },
  data() {
    return {
      year: new Date().getFullYear(),
      month:
        new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1,
      day:
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate(),
      hour:
        new Date().getHours() < 10
          ? '0' + new Date().getHours()
          : new Date().getHours(),
      minute:
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes(),
      second:
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds(),
      nowDistance: 0, // 距离
      userInfo: {},
      clickFlag: false, // 打卡点击标志
      timer: null,
      point: null, // 当前位置经纬度
      isFieldClock: false,
      fileList: [],
      fieldClockParam: {},
      clockInInfo: {},
      isConfirmField: false,
      addressList: {},
      isRemarks: false,
      isRemarke: false,
      geolocationControl: null,
      geolocation: null,
      staffNameInCookies: Cookies.get('lishuiJob'),
      postOfficeInCookies: Cookies.get('lishuiJob'),
      entNameInCookies: Cookies.get('lishuiEntName'),
      mobileInCookies: Cookies.get('lishuiPh'),
      creditCodeInCookies: Cookies.get('lishuiCreditCode'),
      staffTypeInCookies: Cookies.get('lishuiStaffType')
    }
  },
  created() {
    // this.formatDate()
    // 时间
    setInterval(this.formatDate, 1000)
    // 微信授权
    // this.wxAuthorization()
  },
  mounted() {
    this.userInfo = getLocalStorage('lishuiUserInfo')
      ? JSON.parse(getLocalStorage('lishuiUserInfo'))
      : {}
    // 定位
    // this.getPosition()
    this.getCurrentLocation()
    // clearTimeout(this.timer)
    // // 每隔10秒刷新位置
    // let that = this
    // this.timer = setInterval(this.getPosition, 10000)
  },
  computed: {
    isGetUserInfo() {
      return this.$store.state.clock.isGetUserInfo
    }
  },
  watch: {
    isGetUserInfo(v) {
      if (v && getLocalStorage('lishuiUserInfo')) {
        this.userInfo = JSON.parse(getLocalStorage('lishuiUserInfo'))
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    wxAuthorization() {
      const _this = this
      // const link = window.location.href
      // let arr = ''
      // if (
      //   process.env.NODE_ENV === 'development' ||
      //   window.location.href.includes('8824')
      // ) {
      //   // 本地
      //   arr = link.split('/ent.html#')
      // } else {
      //   // 线上
      //   arr = link.split('/?code')
      // }
      // 这里的的参数除了debug和jsApiList，其他都是后端同事获取到后传给前端的
      // let arr = link.split('/ent.html#')
      // console.log('路径', location.href.split('#')[0])

      // let link1 = arr[0]
      getWeChatAddress({ url: location.href.split('#')[0] }).then(res => {
        const { data, code } = res.data

        // console.log(data)
        wx.config({
          debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['getLocation', 'openLocation'] // 必填，需要使用的JS接口列表
        })
        wx.ready(function () {
          // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中。
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              // console.log('99999999999', res)
              var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
              wx.openLocation({
                latitude,
                longitude,
                scale: 18
              })
              // var speed = res.speed // 速度，以米/每秒计
              // var accuracy = res.accuracy // 位置精度
              let paramse = {
                formattedAddress: '暂无省',
                position: {
                  lat: res.latitude,
                  lng: res.longitude
                }
              }

              _this.addressList = paramse
              _this.getClockPosition(paramse.position)
            },
            fail: function (err) {
              alert('获取定位位置信息失败！')
            },
            cancel: function (res) {
              alert('用户拒绝授权获取地理位置')
            }
          })
        })
      })
    },
    getCurrentLocation() {
      let that = this
      const u = navigator.userAgent
      // console.log(u.indexOf('MicroMessenger') > 0)
      if (u.indexOf('MicroMessenger') > 0) {
        // const link = window.location.href
        // let arr = ''
        // if (
        //   process.env.NODE_ENV === 'development' ||
        //   window.location.href.includes('8824')
        // ) {
        //   // 本地
        //   arr = link.split('ent.html#')
        // } else {
        //   // 线上
        //   arr = link.split('?code')
        // }
        // let link1 = arr[0]
        // console.log(JSON.stringify(link1))
        getWeChatAddress(
          {
            url: location.href.split('#')[0]
          },
          location.href.split('#')[0]
        ).then(res => {
          // console.log(res)
          if (res.data.code === '0000') {
            setLocalStorage('jsapi_ticket', res.data.data.jsapi_ticket)
            setLocalStorage('access_token', res.data.data.access_token)
            // console.log(res.data.data)
            wx.config({
              debug: false,
              appId: res.data.data.appId,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.noncestr,
              signature: res.data.data.signature,
              jsApiList: ['getLocation']
            })
          }
        })
        wx.ready(function () {
          console.log('微信注册成功')
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              console.log('wx.getLocation: ' + JSON.stringify(res))
              // const position = {
              //   lat: res.latitude,
              //   lng: res.longitude
              // }
              that.getPositionByLonLats(res.longitude, res.latitude)
              // successCB && successCB(res)
            },
            fail: function (err) {
              console.log('获取定位位置信息失败！' + JSON.stringify(err))
            },
            cancel: function (res) {
              console.log('用户拒绝授权获取地理位置' + JSON.stringify(res))
            }
          })
        })
        wx.error(function () {
          console.log('微信注册失败')
        })
      } else {
        this.getPosition()
      }
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode || this.creditCodeInCookies,
        entName: this.userInfo.entName || this.entNameInCookies,
        mobile: this.userInfo.mobile || this.mobileInCookies
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => { })
      saveUVRecord(params).then(res => { })
    },
    // 通过经纬度获取当前位置信息
    getPositionByLonLats(lng, lat) {
      let that = this
      var lnglatXY = [lng, lat] // 地图上所标点的坐标
      const AMap = window.AMap
      AMap.service('AMap.Geocoder', function () {
        // 回调函数
        const geocoder = new AMap.Geocoder({})
        geocoder.getAddress(lnglatXY, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            let paramse = {
              formattedAddress: result.regeocode.formattedAddress,
              position: {
                lat: lat,
                lng: lng
              }
            }
            // console.log('高德', result)
            that.addressList = paramse
            that.getClockPosition(paramse.position)
          }
        })
      })
    },
    showRemark(res) {
      this.isRemarks = res
    },
    onFailed(errorInfo) { },

    /**
     * @description 显示当前需要填写外勤信息的弹框
     */
    showFieldClock() {
      this.isFieldClock = true
    },

    /**
     * @description 上传图片
     */
    afterRead(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      let _this = this
      let fd = new FormData()
      fd.append('file', file.file)
      uploadImg(fd).then(res => {
        if (res.code === '0000') {
          file.status = 'done'
          this.fieldClockParam.punchOutPic = res.data.ossUrl || ''
          this.$notify({
            type: 'success',
            message: '图片上传成功'
          })
        } else {
          file.status = 'done'
          this.$notify(res.msg || '上传失败')
        }
      })
    },

    // 时间格式化
    formatDate() {
      let date = new Date()
      this.year = date.getFullYear()
      this.month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      this.day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      this.minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      this.second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    },
    // 定位
    getPosition() {
      // 原生获取当前经纬度
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(
      //     function(position) {
      //       console.log(
      //         '原生',
      //         position.coords.longitude,
      //         position.coords.latitude
      //       )
      //     },
      //     function(e) {
      //       throw e.message
      //     }
      //   )
      // }
      // var u = navigator.userAgent
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      let that = this
      // const AMap = window.AMap
      // if (isAndroid) {
      // AMap.plugin('AMap.Geolocation', function() {
      that.geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 1000, // 从timeout毫秒后开始调用，默认（间隔）：5s
        buttonPosition: 'RB', // 定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true // 定位成功后是否自动调整地图视野到定位点
      })
      // console.log(geolocation)
      that.geolocation.getCurrentPosition()
      AMap.event.addListener(that.geolocation, 'complete', onComplete)
      AMap.event.addListener(that.geolocation, 'error', onError)
      function onComplete(data) {
        // data是具体的定位信息
        // console.log(data)
        that.addressList = data
        that.getClockPosition(data.position)
      }
      function onError(data) {
        // 定位出错
        console.log('高德地图失败' + JSON.stringify(data))
        let geolocation2 = new BMap.Geolocation()
        geolocation2.enableSDKLocation()
        geolocation2.getCurrentPosition(function (r) {
          console.log(r)
          if (this.getStatus() == 0) {
            // console.log('百度转之前坐标', r.longitude, r.latitude)
            const { lng, lat } = that.bMapTransQQMap(r.longitude, r.latitude)
            // console.log('百度转之后坐标', lng, lat)
            that.getPositionByLonLats(lng, lat)
          } else {
            that.$notify('获取定位失败：' + this.getStatus())
          }
        })
        // if (AMap.UA.ios && document.location.protocol !== 'https:') {
        //   // 使用远程定位，见 remogeo.js
        //   // eslint-disable-next-line no-undef
        //   var remoGeo = new RemoGeoLocation()
        //   // 替换方法
        //   navigator.geolocation.getCurrentPosition = function() {
        //     return remoGeo.getCurrentPosition.apply(remoGeo, arguments)
        //   }
        //   // 替换方法
        //   navigator.geolocation.watchPosition = function() {
        //     return remoGeo.watchPosition.apply(remoGeo, arguments)
        //   }
        //   that.geolocation.getCurrentPosition()
        // }
      }
      // geolocation.getCurrentPosition(function(status, result) {
      //   if (status == 'complete') {
      //     that.addressList = result
      //     // console.log('高德', result.position.lng, result.position.lat)
      //     that.getClockPosition(result.position)
      //   } else {
      //     that.$notify('高德获取定位失败：' + result.message)
      //   }
      // })
      // })
      // } else {
      // let geolocation2 = new BMap.Geolocation()
      // geolocation2.enableSDKLocation()
      // geolocation2.getCurrentPosition(function(r) {
      //   console.log(r)
      //   if (this.getStatus() == 0) {
      //     // console.log('百度转之前坐标', r.longitude, r.latitude)
      //     const { lng, lat } = that.bMapTransQQMap(r.longitude, r.latitude)
      //     // console.log('百度', lng, lat)
      //     that.getPositionByLonLats(lng, lat)
      //   } else {
      //     that.$notify('百度获取定位失败：' + this.getStatus())
      //   }
      // })
      // }
    },
    // 将百度地图经纬度转换为腾讯/高德地图经纬度        用于大屏
    bMapTransQQMap(longitude, latitude) {
      let x_pi = (Math.PI * 3000.0) / 180.0
      let x = longitude - 0.0065
      let y = latitude - 0.006
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
      let lng = z * Math.cos(theta)
      let lat = z * Math.sin(theta)

      return { lng, lat }
    },
    onErr() {
      var remoGeo = new RemoGeoLocation()
      // 替换方法
      navigator.geolocation.getCurrentPosition = function () {
        return remoGeo.getCurrentPosition.apply(remoGeo, arguments)
      }
      // 替换方法
      navigator.geolocation.watchPosition = function () {
        return remoGeo.watchPosition.apply(remoGeo, arguments)
      }
      this.getPosition()
    },
    // 获取当前手机位置
    getClockPosition(point) {
      const u = navigator.userAgent
      clearTimeout(this.timer)
      console.log(this.userInfo)
      this.timer = null
      this.point = point
      let params = {
        mobile: this.userInfo.mobile || this.mobileInCookies,
        creditCode: this.userInfo.creditCode || this.creditCodeInCookies,
        staffType: this.userInfo.staffType || this.staffTypeInCookies,
        staffName: this.userInfo.staffName,
        province: this.userInfo.province,
        city: this.userInfo.city,
        county: this.userInfo.county,
        addresss: this.userInfo.addresss,
        isNonlocal: this.userInfo.isNonlocal,
        postOffice: this.userInfo.postOffice,
        nowLongitude: point.lng,
        nowtLatitude: point.lat
      }
      let par = {
        lng: point.lng,
        lat: point.lat
      }
      setLocalStorage('nowPoint', JSON.stringify(par))
      clockInInfo(params).then(response => {
        let res = response.data
        if (res.code == '0000') {
          if (res.data) {
            this.clockInInfo = res.data || {}
            this.nowDistance = res.data.nowDistance || 0
            this.placeName = res.data.placeName
            if (this.clockInInfo.punchGroupStatus == 2 || this.clockInInfo.punchDateStatus != 1) { // 未在考勤组
              this.isRemarke = false
            } else {
              this.isRemarke = true
            }

            if (u.indexOf('MicroMessenger') > 0) {
              this.timer = setTimeout(this.getCurrentLocation, 10000)
            } else {
              this.timer = setTimeout(this.getPosition, 10000)
            }
            //
          }
          this.clickFlag = true
        } else {
          this.$notify(res.msg)
          this.clickFlag = false
        }
      })
    },

    // 打卡
    clock(type) {
      this.buriedPoint()
      // 您未在考勤组里
      if (this.clockInInfo.punchGroupStatus == 2) return
      // 外勤打卡
      this.isConfirmField = type === 'on'
      if (this.clockInInfo.punchOutStatus === 1 && !this.isConfirmField) {
        // 您正在使用外勤打卡
        this.isFieldClock = true

        return
      }
      if (!this.clickFlag) {
        this.$notify({ type: 'warning', message: '定位中，请稍后再试' })
        return
      }
      let param = {
        punchOutStatus: this.clockInInfo.punchOutStatus, // 1正常 0外勤
        mobile: this.clockInInfo.mobile,
        punchCardDistance: this.clockInInfo.nowDistance,
        creditCode: this.clockInInfo.creditCode,
        nowLongitude: this.point.lng,
        nowtLatitude: this.point.lat,
        placeName: this.placeName
      }

      if (this.clockInInfo.punchOutStatus == 1) {
        param.punchOutThs = this.fieldClockParam.punchOutThs || ''
        param.punchOutPic = this.fieldClockParam.punchOutPic || ''
      }

      clockIn(param).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.isFieldClock = false
          this.fileList = []
          this.fieldClockParam.punchOutThs = ''
          this.$notify({
            type: this.clockInInfo.punchOutStatus === 1 ? 'warning' : 'success',
            message:
              this.clockInInfo.punchOutStatus === 1
                ? '异地办公打卡成功'
                : '打卡成功'
          })
          this.getPosition()
        } else {
          this.$notify(res.msg || '打卡失败')
        }
      })
    },
    // 备注记录
    record() {
      this.isRemarks = true
      this.buriedPoint()
    }
  }
}
</script>

<style lang="scss" scoped>
#punchClock {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
  .remark {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .popup_remark {
    width: 80%;
    height: 40px;
    line-height: 40px;
    color: rgba(70, 125, 255, 0.9);
    border-radius: 8px;
    background-color: rgba(238, 243, 255, 1);
    border: 2px solid rgba(70, 125, 255, 0.8);
    text-align: center;
    font-size: 16px;
    margin: -20px auto 0;
    font-weight: 600;
    position: relative;
    i {
      position: absolute;
      left: 20px;
      top: 10px;
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('~@/assets/images/remark.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .c-t {
    height: 120px;
    background: url('~@/assets/images/lishui-sbg.jpg') no-repeat;
    background-size: 100% 100%;
  }
  .c-m {
    position: absolute;
    top: 30px;
    left: 30px;
    width: calc(100% - 100px);
    border-radius: 6px;
    background: #fff;
    box-shadow: 0px 40px 40px 0px rgba(210, 214, 224, 0.3);
    display: flex;
    align-items: center;
    padding: 20px 20px 40px 20px;
    &-l {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
      background: url('~@/assets/images/lishui-user.png') no-repeat;
      background-size: 100% 100%;
    }
    &-r {
      div:nth-of-type(1) {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      div:nth-of-type(2) {
        color: #666666;
        font-size: 14px;
      }
    }
    &-remark {
      margin-left: 130px;
      font-size: 13px;
      color: #999;
      i {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url('~@/assets/images/lishui-user.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .c-c {
    flex: 1;
    background: #fff;
    &-clock {
      padding-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .entName {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
      }
      .date-time {
        font-size: 14px;
        color: #000;
        margin-bottom: 40px;
      }
      .clock {
        width: 220px;
        height: 220px;
        border-radius: 50%;
        color: #fff;
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &-text {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        &-time {
          font-size: 16px;
          opacity: 0.5;
        }
        &.e {
          background: url('~@/assets/images/lishui-eClock.png') no-repeat;
          background-size: 100% 100%;
        }
        &.une {
          background: url('~@/assets/images/lishui-uneClock.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .address {
        font-size: 14px;
        transform: translateY(-50px);
        i {
          color: #467dff;
          margin-right: 8px;
        }
        span {
          color: #467dff;
        }
      }
      .address-name {
        margin-top: 4px;
        font-size: 14px;
        text-align: center;
      }
    }
  }

  ::v-deep .van-popup {
    padding: 20px;
    box-sizing: border-box;
    .field-msg {
      font-size: 14px;
      text-align: center;
    }

    .field-info {
      margin-top: 20px;
      .field-detail {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-field {
          height: 80px;
          border-bottom: 1px solid #bbb;
          width: calc(100% - 100px);
        }
        .van-uploader {
          // border: 1px solid #bbb;
          .van-uploader__upload,
          .van-uploader__preview {
            margin: 0;
          }
        }
      }
    }

    .field-clock-btn {
      margin: 15px auto;
      display: flex;
      height: 30px;
      width: 100%;
      text-align: center;
      .van-button__content {
        margin: 0 auto;
      }
    }
  }
}
</style>
